import { Box, Button, Container, Grid, Typography } from "@material-ui/core";
import TableToExcel from "@linways/table-to-excel";

import React, { useEffect, useState } from "react";
import Dashboard from "../../../Components/Dashboard";
import Denied from "../../../Components/Denied";
import { apiEmbalei, apiLabs } from "../../../Services/api";
import history from "../../../Services/history";
import { store } from "../../../store";
import stylePagesEmbalei from "../style";
import GetAppIcon from "@material-ui/icons/GetApp";
import "date-fns";
import { ptBR } from "date-fns/locale";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import format from "date-fns/format";
import { toast } from "react-toastify";
import ChartComponent from "../../../Components/Chart/ChartEmbalei";

function Ranking(props) {
  const style = stylePagesEmbalei();
  const MAX_DATE = new Date();
  const {
    location: { idPage },
  } = props;

  const [operator, setOperator] = useState([]);
  const [totalOrders, setTotalOrders] = useState("");

  const [date, setDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [disableInputs, setDisableInputs] = useState(false);

  const [auth, setAuth] = useState(null);

  async function verifyAuth() {
    const { profile } = store.getState().user;
    const res = await apiLabs.post("valid_key", {
      id: profile.id,
      menu_id: idPage,
    });
    if (res.data.message === "User not authorized") {
      return setAuth("denied");
    }
    if (res.data.message === "User authorized") {
      return setAuth("authorized");
    }
    return history.push({ pathname: "/", state: { from: props.location } });
  }

  const compareDates = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    return start <= end;
  };

  const isDate = (date) => {
    return new Date(date) !== "Data inválida!" && !isNaN(new Date(date));
  };

  const handleDate = (dateInput) => {
    if (dateInput === "" || dateInput === null || !isDate(dateInput)) {
      setDate("Invalid Date");
      setDisableInputs(true);
    } else {
      setDate(dateInput);
      setDisableInputs(false);
    }
    if (compareDates(endDate, dateInput)) {
      setEndDate(dateInput);
      setDisableInputs(false);
      return;
    }
  };

  const handleEndDate = (dateFinal) => {
    if (compareDates(date, dateFinal)) {
      setEndDate(dateFinal);
      return;
    }
    setEndDate(new Date());
  };

  async function getOrders() {
    try {
      const res = await apiEmbalei.get(
        `ranking?data=${format(new Date(date), "yyyy-MM-dd")}&enddata=${format(
          new Date(endDate),
          "yyyy-MM-dd"
        )}`
      );

      const total = res.data.reduce(
        (accumulator, order) => accumulator + order.total_pedidos,
        0
      );
      setTotalOrders(total);
      setOperator(res.data);
    } catch (error) {
      console.log(error);
    }
  }

  function jsonToTable(json) {
    const table = document.createElement("table");
    table.setAttribute("data-js", "export-table-excel");

    const thead = document.createElement("thead");

    const tbody = document.createElement("tbody");
    tbody.setAttribute("data-js", "table-body-excel");

    const headerRow = document.createElement("tr");
    Object.keys(json[0]).forEach((key) => {
      const th = document.createElement("th");
      th.textContent = key.toLocaleUpperCase();
      headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);

    json.forEach((item) => {
      const row = document.createElement("tr");
      Object.values(item).forEach((value) => {
        const td = document.createElement("td");
        td.textContent = value;
        row.appendChild(td);
      });
      tbody.appendChild(row);
    });

    table.appendChild(thead);
    table.appendChild(tbody);

    return table;
  }

  async function getNumbersOrdersToExcel() {
    try {
      const res = await apiEmbalei.get(
        `excel?data=${format(new Date(date), "yyyy-MM-dd")}&enddata=${format(
          new Date(endDate),
          "yyyy-MM-dd"
        )}`
      );
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    verifyAuth();
  }, []);

  useEffect(() => {
    getOrders();
  }, [date, endDate]);

  async function ExportToExcel() {
    const table = document.querySelector("[data-js='export-table-excel']");
    const tableBody = document.querySelector("[data-js='table-body-excel']");

    if (tableBody.children.length > 0) {
      TableToExcel.convert(table, {
        name: `raking-${format(new Date(date), "dd/MM/yyyy")}-a-${format(
          new Date(endDate),
          "dd/MM/yyyy"
        )}.xlsx`,
        sheet: {
          name: "Sheet 1",
        },
      });
      toast.success(`Dados exportados com sucesso!`, {
        autoClose: 5000,
      });
    } else {
      toast.warn(`Não há dados para exportar!`, {
        autoClose: 5000,
      });
    }
  }

  async function ExportOrdersToExcel() {
    const tableBody = document.querySelector("[data-js='table-body-excel']");

    const result = await getNumbersOrdersToExcel();
    const tableNumberPedidos = jsonToTable(result);

    if (tableBody.children.length > 0) {
      TableToExcel.convert(tableNumberPedidos, {
        name: `Pedidos-de-${format(new Date(date), "dd/MM/yyyy")}-a-${format(
          new Date(endDate),
          "dd/MM/yyyy"
        )}.xlsx`,
        sheet: {
          name: `Pedidos`,
        },
      });
      toast.success(`Dados exportados com sucesso!`, {
        autoClose: 5000,
      });
    } else {
      toast.warn(`Não há dados para exportar!`, {
        autoClose: 5000,
      });
    }
  }

  return (
    <Dashboard title="Ranking Embalei">
      {auth === "denied" && <Denied />}
      {auth === "authorized" && (
        <Container maxWidth="md">
          <Grid container spacing={2}>
            <Grid
              container
              alignContent="center"
              alignItems="flex-start"
              xs={12}
            >
              <Grid xs={12}>
                <Typography className={style.titlePage}>
                  Ranking Geral
                </Typography>
                <Box display="flex" className={style.boxFilter}>
                  <Grid xs={8}>
                    <Typography>Empacotados do dia</Typography>
                    <Box>
                      <MuiPickersUtilsProvider
                        utils={DateFnsUtils}
                        locale={ptBR}
                      >
                        <KeyboardDatePicker
                          className={style.dateRanking}
                          inputVariant="outlined"
                          disableToolbar
                          variant="inline"
                          format="dd/MM/yyyy"
                          margin="normal"
                          id="date-ranking"
                          onChange={handleDate}
                          value={date}
                          maxDate={MAX_DATE}
                          label="de"
                          invalidDateMessage="Data inválida"
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                        />
                        <KeyboardDatePicker
                          disabled={disableInputs}
                          className={style.dateRanking}
                          inputVariant="outlined"
                          disableToolbar
                          variant="inline"
                          format="dd/MM/yyyy"
                          margin="normal"
                          id="date-ranking-end"
                          onChange={handleEndDate}
                          value={endDate}
                          maxDate={MAX_DATE}
                          minDate={date}
                          label="até"
                          invalidDateMessage="Data inválida"
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </Box>
                  </Grid>

                  <Grid xs={4} className={style.buttonsDowload} display="flex" alignItems="center">
                    <Typography>Baixar resultados</Typography>
                    <Button
                      disabled={disableInputs}
                      variant="contained"
                      color="primary"
                      onClick={ExportToExcel}
                      className={style.exportExcel}
                    >
                      <GetAppIcon /> RANKING
                    </Button>
                    <Button
                      disabled={disableInputs}
                      variant="contained"
                      color="primary"
                      onClick={ExportOrdersToExcel}
                      className={style.exportExcel}
                    >
                      <GetAppIcon /> PEDIDOS
                    </Button>
                  </Grid>
                </Box>
                <Container>
                  <Typography>Gráfico de pedidos</Typography>
                  <ChartComponent date={date} endDate={endDate} />
                </Container>
              </Grid>
              <Grid xs={2}></Grid>
            </Grid>

            <Grid item xs={12}>
              <Typography className={style.totalOrders}>
                Total de pedidos: {totalOrders}
              </Typography>
              <table
                className={style.tableEmbalei}
                border={0}
                cellSpacing={0}
                data-js="export-table-excel"
              >
                <thead>
                  <tr>
                    <th align="left">Colocação</th>
                    <th align="left">Pedidos</th>
                    <th align="left">Média</th>
                    <th align="left">Total de itens</th>
                    <th align="left">Operador</th>
                    <th align="left">Data</th>
                  </tr>
                </thead>

                <tbody data-js="table-body-excel">
                  {operator.map((o, i) => (
                    <tr key={`operator-${i}`}>
                      <td>{++i}º Lugar</td>
                      <td>{o.total_pedidos}</td>
                      <td>{o.meta}</td>
                      <td>{o.total_itens}</td>
                      <td>{o.name}</td>
                      <td>{o.beep_date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Grid>
          </Grid>
        </Container>
      )}
    </Dashboard>
  );
}

export default Ranking;
